import { createFileRoute } from '@tanstack/react-router';
import { DashboardsHubPage } from '@/features/dashboards/dashboards-hub-page';

export const Route = createFileRoute('/w/$workspaceId/dashboards/')({ component: DashboardsHubPage });
